<template lang="html">

  <section class="login">
    <div class="wrapper d-flex align-items-center auth login-full-bg h-100">
      <div class="row w-100">
        <div class="col-lg-6 mx-auto box-login">
          <div class="auth-form-dark text-left p-5">
            <div class="text-center mb-5">
              <img src="@/assets/images/consulta-ja-logo.svg" width="50%" alt="Consulta Já" />
            </div>
            <h2>Redefinir senha</h2>
            <h4 class="font-weight-light">Preencha os dados abaixo para redefinir a sua senha</h4>
            <form class="pt-5" autocomplete="off">
              <form autocomplete="off">
                <div class="form-group">
                  <label for="email">E-mail</label>
                  <input type="email" v-model="email" class="form-control" id="email" @keyup.enter="resetPassword">
                  <i class="mdi mdi-account"></i>
                </div>
                <div class="form-group">
                  <label for="password">Nova senha</label>
                  <input type="password" v-model="password" class="form-control" id="password" @keyup.enter="resetPassword">
                  <i class="mdi mdi-eye"></i>
                </div>
                <div class="form-group">
                  <label for="password_confirmation">Confirmar nova senha</label>
                  <input type="password" v-model="password_confirmation" class="form-control" id="password_confirmation" @keyup.enter="resetPassword">
                  <i class="mdi mdi-eye"></i>
                </div>
                <div class="mt-5">
                  <a class="btn btn-block btn-primary btn-lg font-weight-medium" @click="resetPassword">Redefinir senha</a>
                </div>
                <div class="mt-3 text-center">
                  <router-link to="/login" class="login-link mt-3">Voltar para o login</router-link>
                </div>
              </form>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">
export default {
  data () {
    return {
      isLoading: null,

      email: this.$route.query.email
    }
  },
  created: function () {
    if (this.api.isLogged()) {
      this.eventBus.$emit('IS_LOGGED', true);
      this.$router.push('/');
    }
  },
  mounted() {
    this.eventBus.$on('IS_LOADING', (isLoading) => {
      if(isLoading) {
        if(typeof this.isLoading != 'undefined' && this.isLoading != null) {
          return;
        }
        this.isLoading = this.$loading.show({
          container: this.$refs.homeContent,
          canCancel: false,
          isFullPage: false,
          color: '#21A7F0',
          backgroundColor: '#212C3B'
        });
      } else {
        if(typeof this.isLoading != 'undefined' && this.isLoading != null) {
          this.isLoading.hide();
          this.isLoading = null;
        }
      }
    });
  },
  methods: {
    resetPassword () {
      if(this.password == 'undefined' || this.password == '') {
        this.$swal('Ops...', 'Senha inválida!', 'error');
        return false;
      }
      if (this.password != this.password_confirmation) {
        this.$swal('Ops...', 'As senhas digitadas não conferem!', 'error');
        return false;
      }

      this.eventBus.$emit('IS_LOADING', true);
      this.api.resetPassword({ token:this.$route.params.token, email: this.email, password: this.password }).then(() => {
        this.eventBus.$emit('IS_LOADING', false);
        this.$swal('Uhull \\o/', 'Sua senha foi redefinida!', 'success');
        this.$router.push('/login');
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        let response = err.response;
        let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos validar os seus dados! Verifique as informações digitadas e tente novamente.';

        this.$swal('Ops...', message, 'error');

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error', err);
      })
    }
  }
}
</script>

<style scoped lang="scss">
.login {
  height: 100vh;
  background-image: linear-gradient(to bottom right, #eaeaea , #cccccc);

  .login-full-bg {
    background: url(../assets/images/bg-login.jpg) center center;
  }

  .box-login {
    font-family: 'sf_pro_displaymedium';
    background-color: #000000;
    color: #ffffff;
  }

  .login-link {
    color: #ffffff;
    font-size: 18px;
  }
}
</style>
